import { useEffect, useState } from "react";
import "./ReservationPage.scss";

export default function ReservationSuccessPage() {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      window.location.replace("/");
      return;
    }

    async function verifyReservation() {
      try {
        const response = await fetch(
          `https://kotamconquest.com/api/verify-reservation.php?session_id=${encodeURIComponent(sessionId)}`
        );

        const data = await response.json();

        if (data.success) {
          sessionStorage.setItem("kotam_reservation_complete", "true");
          setStatus("success");
        } else {
          window.location.replace("/");
        }
      } catch (error) {
        console.error(error);
        setStatus("error");
      }
    }

    verifyReservation();
  }, []);

  if (status === "checking") {
    return (
      <main className="reservation-page">
        <section className="reservation-card">
          <span className="reservation-eyebrow">Confirming reservation</span>
          <h1>Checking Your Reservation</h1>
          <p>Please wait while we confirm your $1 reservation.</p>
        </section>
      </main>
    );
  }

  if (status === "error") {
    return (
      <main className="reservation-page">
        <section className="reservation-card">
          <span className="reservation-eyebrow">Something went wrong</span>
          <h1>We Could Not Confirm Your Reservation</h1>
          <p>
            Your payment may still have gone through. Please contact support if
            you do not receive a confirmation email.
          </p>
          <a href="/" className="btn btn-primary">Back to Kotam</a>
        </section>
      </main>
    );
  }

  return (
    <main className="reservation-page">
      <section className="reservation-card reservation-card--success">
        <span className="reservation-eyebrow">Reservation confirmed</span>

        <h1>Your 3D Barrack Promo Is Reserved</h1>

        <p>
          Thank you for reserving early access for Kotam: Conquest. We will email
          you before Kickstarter launch with details about your 3D Barrack promo.
        </p>

        <div className="reservation-next">
          <h2>Next Step</h2>
          <p>
            Follow Kotam: Conquest on Kickstarter so you are notified the moment
            the campaign goes live.
          </p>

          <a
            href="https://www.kickstarter.com/projects/your-project/kotam-conquest"
            className="btn btn-primary"
            target="_blank"
            rel="noreferrer"
          >
            Follow on Kickstarter
          </a>
        </div>

        <a href="/" className="reservation-link">Back to landing page</a>
      </section>
    </main>
  );
}